import React, { Component } from 'react';
import { partnerApi, getAllverticalData, findTeachers } from  './../../../API/FetchCall';
import SimpleReactValidator from 'simple-react-validator';
 
import {
  Collapse,
  CardBody,
  Card,
  CardHeader
} from 'reactstrap';
class TalentSearch extends Component {

  constructor(props) {
    
    super(props);
      this.state = {
          logged: localStorage.getItem("authentication"),
          auth_data: JSON.parse(localStorage.getItem("user_data")),
          write_permission: true,
          subject: '',
          experience: '',
          city:'',
          teachersList:[]
      }

     this.findatalent = this.findatalent.bind(this);
      

  }
 
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

   
  findatalent = () => {

    let req = JSON.stringify({
        subject:this.state.subject,
         experience:this.state.experience,
          city:this.state.city,
    });

    findTeachers(req).then(res => {
      if (res.status === 1) {
        this.setState({
          teachersList: res.results
        })
      }
    })

  }

  render() {
  
    const { teachersList } = this.state;

    return (
      <React.Fragment>
        <div className="">
          <h3 className="page-header">Talent Search</h3>
           
          { /* 
          <div class="form-group hidden">
            

            <div class="form-row">

               <div class="col-md-4">
                    <select class="form-control" name="subject" onChange={this.handleChange}>
                            <option value="">select subject</option>
                            <option value="maths">Mathematics</option>
                            <option value="english">English</option>
                            <option value="tamil">Tamil</option>
                            <option value="science">Science</option>
                    </select>
               </div>
               <div class="col-md-4">
                  <select class="form-control" name="experience" onChange={this.handleChange}>
                            <option value="">select experience</option>
                            <option value="2-5">2-5 Years</option>
                            <option value="5-10">5-10 Years</option>
                            <option value="<10">10 Years Above</option>
                  </select>
               </div>
               <div class="col-md-4">
                  <select class="form-control" name="city" onChange={this.handleChange}>
                            <option value="">select city</option>
                            <option value="bengaluru">Bengaluru</option>
                            <option value="chennai">Chennai</option>
                  </select>
               </div>

                
            </div>


          </div>

          <div class="col-md-4">
            
            <button class="btn btn-primary btn-sm" onClick={this.findatalent}>Find a Talent</button>
          </div>

          <div class="container-fluid">
            
            <div class="row">

              {teachersList.map((item, i) => {   

              return <div class="col-md-12">
                       <div class="row">
                            <div class="columnwc">
                              <div class="cardwc">
                                <h3>{item.name} </h3>
                                <p>{item.email_id}</p>
                                <p><button class="btn btn-primary btn-sm">view more</button></p>
                              </div>
                            </div>
                       </div>
                      </div>

              })

              }
 
            </div>

          </div>

            */ }

          <p>Coming soon</p>  

        </div>
      </React.Fragment>
    );
  }
  
}

export default TalentSearch;



// WEBPACK FOOTER //
// ./src/components/bewise/partners/tabbedtalentsearch.jsx